<template>
  <div class="allActiveTecDetail">
    <div class="header">
      <el-row :gutter="1" type="flex">
        <el-col :span="9"
          ><span class="title">统计日期:</span>
          <datePicker
            :value="{
              startDate: searchForm.startDate,
              endDate: searchForm.endDate
            }"
            @dateValue="dateValue"
          />
        </el-col>
        <el-col :span="6"
          ><span class="title">省市区:</span
          ><el-cascader
            :options="options"
            v-model="cityValue"
            :props="{ multiple: true }"
            collapse-tags
            clearable
            @change="cityChange"
            @visible-change="cityVisible"
            @remove-tag="removeTag"
          ></el-cascader
        ></el-col>
        <el-col :span="6"
          ><span class="title">学校:</span
          ><filterSelect
            ref="filterSelect"
            :optionsList="schoolList"
            :defaultChecked="defaultSchool"
            @checked="schoolChecked"
        /></el-col>
        <el-col :span="3"
          ><div class="btn">
            <el-button size="small" @click="reset">重置</el-button>
            <el-button type="primary" size="small" @click="search">查询</el-button>
          </div></el-col
        >
      </el-row>
    </div>
    <div class="content">
      <div class="hint">
        <div class="left">
          <el-radio-group size="small" v-model="radio1" @change="radioChange">
            <el-radio-button label="一级分类"></el-radio-button>
            <el-radio-button label="二级分类"></el-radio-button>
          </el-radio-group>
          <el-popover
            style="margin-left: 5px"
            placement="bottom-start"
            :width="radio1 == '一级分类' ? '400' : '700'"
            trigger="hover"
            :visible-arrow="false"
            popper-class="popper-hint"
          >
            <div v-html="radio1 == '一级分类' ? XXJSYJFL : XXJSEJFL"></div>
            <i class="el-icon-info" slot="reference"></i>
          </el-popover>
        </div>
        <div class="center">
          <el-radio-group v-model="radio2" @change="radioChange">
            <el-radio label="活跃明细">活跃明细</el-radio>
            <el-radio label="未活跃明细">未活跃明细</el-radio>
          </el-radio-group>
        </div>
        <div class="right">
          <el-button type="primary" size="small" @click="downExcel" :loading="downLoading">导出数据</el-button>
        </div>
      </div>
      <div class="table">
        <el-table
          :data="tableData"
          :key="'allActiveTecDetail' + keyTable"
          ref="table"
          border
          size="small"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          stripe
          height="100%"
          @sort-change="sortChange"
          :default-sort="{ prop: 'functionUse', order: 'descending' }"
          v-loading="loading"
        >
          <el-table-column fixed type="index" label="排名" width="80">
            <template slot-scope="scope">
              <span>{{ (searchForm.pageNum - 1) * searchForm.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <template v-if="radio2 == '未活跃明细'">
            <el-table-column
              v-for="(item, index) in tableNotAct"
              :key="index"
              :prop="item.prop"
              :fixed="item.fixed"
              :label="item.label"
              :width="item.width"
            >
            </el-table-column>
          </template>
          <template v-if="radio1 == '一级分类' && radio2 == '活跃明细'">
            <el-table-column
              v-for="(item, index) in tableLabel1"
              :key="index"
              :fixed="item.fixed"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sort"
            >
            </el-table-column>
          </template>
          <template v-if="radio1 == '二级分类' && radio2 == '活跃明细'">
            <el-table-column
              v-for="(item, index) in tableLabel2"
              :key="index"
              :fixed="item.fixed"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sort"
            >
              <el-table-column
                v-for="(item2, index2) in item.children"
                :key="index2"
                :fixed="item2.fixed"
                :label="item2.label"
                :prop="item2.prop"
                :width="item2.width"
                :sortable="item2.sort"
              >
              </el-table-column>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <div class="pagSize">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="searchForm.pageSize"
          :current-page.sync="searchForm.pageNum"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from '../../components/FilterSelect/index.vue'
import datePicker from '../../components/datePicker/index.vue'
import { lastWeek } from '@/utils/date.js'
import { XXJSYJFL, XXJSEJFL } from '@/utils/explainText.js'
import { resize } from '@/mixins/resize.js'
// import { saveAs } from 'file-saver'
import fileSave from '@/utils/fileSave.js'

import { allActiveTeaFirstDetail, allActiveTeaSecondDetail } from '@/api/modules/excelApi.js'
import { generateTableParms, getToken, excelName } from '@/utils/index.js'
import { isBack } from '@/mixins/isBack.js'
export default {
  name: 'AllActiveTecDetail',
  mixins: [resize, isBack],
  components: {
    filterSelect,
    datePicker
  },
  data() {
    return {
      XXJSYJFL: XXJSYJFL,
      XXJSEJFL: XXJSEJFL,
      schoolList: JSON.parse(sessionStorage.getItem('schoolList')),
      options: JSON.parse(sessionStorage.getItem('cityList')),
      cityValue: [],
      searchForm: {
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key,
        startDate: lastWeek().startOf,
        endDate: lastWeek().endOf,
        pageSize: 12,
        pageNum: 1,
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        schoolIds: [],
        sortCode: 'functionUse',
        ascOrDes: false //false是降序,true是升序
      },
      address: {
        provinceIds: [],
        cityIds: [],
        localeIds: [],
        loginUserId: JSON.parse(sessionStorage.getItem('userInfo')).Key
      },
      emptyIsShow: false,
      tableData: [],
      keytable: 0,
      loading: false,
      total: 0,
      radio1: '一级分类',
      radio2: '活跃明细',
      tableLabel1: [
        {
          prop: 'schoolName',
          label: '学校名称',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'teacherName',
          label: '教师名称',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'alreadyLoggedText',
          label: '是否登录',
          sort: false,
          fixed: false,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'lesson',
          label: '备课',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'classLesson',
          label: '上课',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'tasks',
          label: '作业',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'aiCard',
          label: '智能卡',
          sort: 'custom',
          fixed: false,
          width: ''
        }
      ],
      tableLabel2: [
        {
          prop: 'schoolName',
          label: '学校名称',
          sort: false,
          fixed: true,
          width: ''
        },
        {
          prop: 'teacherName',
          label: '教师名称',
          sort: false,
          fixed: true,
          width: ''
        },
        {
          prop: 'alreadyLoggedText',
          label: '是否登录',
          fixed: true,
          sort: false,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          sort: 'custom',
          fixed: false,
          width: ''
        },
        {
          prop: 'date',
          label: '备课',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'courseModule',
              label: '课程模块',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'management',
              label: '班级管理',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'courseWare',
              label: '备课-查看课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'classCourseWare',
              label: '上传课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'shareCourseWare',
              label: '分享课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'splendidMoment',
              label: '精彩瞬间',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: '',
          label: '上课工具',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'drawingBoard',
              label: '画板',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'projection',
              label: '同步投影',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'timer',
              label: '计时器',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'randomRollCall',
              label: '随机点名',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'randomCourseware',
              label: '使用课件',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'others',
              label: '其他',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: 'date',
          label: '作业',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'homework',
              label: '布置作业选题模块',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'knowledge',
              label: '知识点',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'achievement',
              label: '作业-查看成绩',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'publishHteNum',
              label: '布置作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'collectHteNum',
              label: '收集作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'correctHteNum',
              label: '批改作业',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'explainHteNum',
              label: '讲解作业',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        },
        {
          prop: 'date',
          label: '智能卡',
          sort: false,
          fixed: false,
          width: '',
          children: [
            {
              prop: 'collectAiCard',
              label: '收集智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'correctAiCard',
              label: '批改智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'aiCardAchievement',
              label: '智能卡-查看智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            },
            {
              prop: 'explainAiCard',
              label: '讲解智能卡',
              sort: 'custom',
              fixed: false,
              width: ''
            }
          ]
        }
      ],
      tableNotAct: [
        {
          prop: 'schoolName',
          label: '学校名称',
          fixed: false,
          width: ''
        },
        {
          prop: 'teacherName',
          label: '教师名称',
          fixed: false,
          width: ''
        },
        {
          prop: 'alreadyLoggedText',
          label: '是否登录',
          fixed: false,
          width: ''
        },
        {
          prop: 'functionUse',
          label: '功能使用度',
          fixed: false,
          width: ''
        }
      ],
      keyTable: 12,
      defaultSchool: [],
      downLoading: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let info = JSON.parse(this.$route.query.info)
      this.searchForm.startDate = info.startDate
      this.searchForm.endDate = info.endDate
      this.searchForm.provinceIds = info.address.provinceIds
      this.searchForm.cityIds = info.address.cityIds
      this.searchForm.localeIds = info.address.localeIds
      this.searchForm.schoolIds = info.schoolIds
      info.schoolIds.forEach((ele) => {
        let i = this.schoolList.findIndex((el) => el.value == ele)
        this.defaultSchool.push(this.schoolList[i])
      })
      this.cityValue = info.cityValue

      this.getTeaDetailsFirst()
    },
    search() {
      this.searchForm.pageNum = 1
      this.axiosIf()
    },
    reset() {
      let info = JSON.parse(this.$route.query.info)
      this.searchForm = this.$options.data().searchForm
      this.cityValue = []
      this.address = this.$options.data().address
      this.keytable += 1
      this.schoolList = JSON.parse(sessionStorage.getItem('schoolList'))
      this.searchForm.startDate = info.startDate
      this.searchForm.endDate = info.endDate
      this.searchForm.provinceIds = info.address.provinceIds
      this.searchForm.cityIds = info.address.cityIds
      this.searchForm.localeIds = info.address.localeIds
      this.searchForm.schoolIds = info.schoolIds
      let filterSelectCheckedValue = ''
      info.schoolIds.forEach((ele) => {
        let i = this.schoolList.findIndex((el) => el.value == ele)
        this.defaultSchool.push(this.schoolList[i])
        filterSelectCheckedValue += this.schoolList[i].label
      })
      this.$refs.filterSelect.checkedValue = filterSelectCheckedValue
      this.cityValue = info.cityValue
      this.axiosIf()
    },
    dateValue(v) {
      this.searchForm.startDate = v.startDate
      this.searchForm.endDate = v.endDate
    },
    cityChange(v) {
      this.address = this.$options.data().address
      this.searchForm.provinceIds = this.searchForm.cityIds = this.searchForm.localeIds = []
      if (v.length < 1) {
        this.getSchools()
      }
      v.forEach((el) => {
        this.address.provinceIds.push(el[0])
        this.searchForm.provinceIds = this.address.provinceIds
        this.address.cityIds.push(el[1])
        this.searchForm.cityIds = this.address.cityIds
        this.address.localeIds.push(el[2])
        this.searchForm.localeIds = this.address.localeIds
      })
    },
    // 省市区选择器收起时
    cityVisible(v) {
      if (!v && this.address.provinceIds.length > 0) {
        // console.log("请求");
        this.getSchools()
      }
    },
    removeTag(v) {
      // console.log(v);
      let i = this.address.provinceIds.findIndex((el) => el == v[0])
      this.address.provinceIds.splice(i, 1)
      this.address.cityIds.splice(i, 1)
      this.address.localeIds.splice(i, 1)
      if (this.address.provinceIds.length > 0) {
        this.getSchools()
      }
    },
    schoolChecked(v) {
      this.searchForm.schoolIds = []
      v.forEach((el) => {
        this.searchForm.schoolIds.push(el.value)
      })
    },
    sortChange({ column, prop, order }) {
      this.searchForm.sortCode = prop
      if (order !== null) {
        order == 'descending' ? (this.searchForm.ascOrDes = false) : (this.searchForm.ascOrDes = true)
        this.axiosIf()
      }
    },
    radioChange() {
      this.searchForm.pageNum = 1
      this.keyTable++
      this.searchForm.sortCode = 'functionUse'
      this.searchForm.ascOrDes = false
      this.axiosIf()
    },
    // 请求接口判断
    axiosIf() {
      if (this.radio1 == '一级分类') {
        this.getTeaDetailsFirst()
      } else {
        this.getTeaDetailsSecond()
      }
    },
    downExcel() {
      this.downLoading = true

      let obj = {
        fileName: '',
        ...this.searchForm,
        ...getToken()
      }
      delete obj.pageSize
      delete obj.pageNum

      obj.fileName = excelName('教师活跃明细', obj.startDate, obj.endDate) + '.xlsx'
      fileSave(allActiveTeaFirstDetail + generateTableParms(obj), obj.fileName).then(() => {
        this.downLoading = false
      })
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.axiosIf()
    },
    // 日常数据—学校教师明细-一级分类
    getTeaDetailsFirst() {
      this.loading = true
      this.$API.allActiveSchApi
        .getTeaDetailsFirst(this.searchForm)
        .then((res) => {
          // console.log(res);
          if (this.radio2 == '活跃明细') {
            this.tableData = res.result.schoolTeaActive
          } else {
            this.tableData = res.result.schoolTeaNotActive
          }
          if (this.tableData !== null && this.tableData.length > 0) {
            this.total = this.tableData[0].total
            this.tableData.forEach((el) => {
              el.alreadyLogged ? (el.alreadyLoggedText = '是') : (el.alreadyLoggedText = '否')
            })
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 日常数据—学校教师明细-二级分类
    getTeaDetailsSecond() {
      this.loading = true
      this.$API.allActiveSchApi
        .getTeaDetailsSecond(this.searchForm)
        .then((res) => {
          // console.log(res);
          if (this.radio2 == '活跃明细') {
            this.tableData = res.result.schoolTeaActive
          } else {
            this.tableData = res.result.schoolTeaNotActive
          }
          if (this.tableData !== null && this.tableData.length > 0) {
            this.total = this.tableData[0].total
            this.tableData.forEach((el) => {
              el.alreadyLogged ? (el.alreadyLoggedText = '是') : (el.alreadyLoggedText = '否')
            })
          } else {
            this.tableData = []
            this.total = 0
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 获取学校列表
    getSchools() {
      this.$API.basicsApi.getSchoolList(this.address).then((res) => {
        console.log(res)
        this.searchForm.schoolIds = []
        this.$refs.filterSelect.checkedValue = ''
        this.schoolList = res.result.map((el) => {
          el.label = el.schoolName
          el.value = el.schoolId
          delete el.schoolId
          delete el.schoolName
          delete el.total
          return el
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.allActiveTecDetail {
  @include myMain();
  .header {
    @include myHeader();
  }
  .content {
    @include myContent();
    .hint {
      @include myContent-hint();
    }
    .table {
      @include myTable();
    }
    .pagSize {
      @include myPagSize();
    }
  }
}
</style>
